<script>
    import Timeframe from './Timeframe.svelte';
    import { _ } from 'svelte-i18n';

    let { value = [], date = null, availableTimeframes = null, onChange = () => {} } = $props();
</script>

<div class="waitlist">
    <h3>{$_('waitlist_title')}</h3>
    <p>{$_('waitlist_description')}</p>

    <Timeframe {value} {date} {availableTimeframes} {onChange} />
</div>

<style>
    .waitlist {
        flex: 1;
    }

    h3 {
        font-family: var(--theme-alt-font-family);
        font-weight: var(--theme-font-weight);
        font-size: 1.5em;
        margin: 0 0 0.5em 0;
    }

    p {
        margin: 0 0 1.5em 0;
        font-size: 0.95em;
    }
</style>
